import TagsBoxShowAll from 'components/TagsBoxShowAll';
import { Strategy } from 'crono-fe-common/types/strategy';
import { useMemo } from 'react';
import { TagsTooltipForStrategyWrapper } from './style';
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { colors } from 'crono-fe-common/theme';

interface IProps {
  strategy: Strategy;
}

const TagsTooltipForStrategy = ({ strategy }: IProps) => {
  const currentSituationTags = useMemo(() => {
    return (
      strategy.tags?.map((tag) => ({
        externalPropertyId: tag.externalPropertyId,
        option: tag.value,
      })) ?? []
    );
  }, [strategy]);
  const numerOfValuesSelected = useMemo(() => {
    return currentSituationTags.length;
  }, [currentSituationTags]);
  return (
    numerOfValuesSelected > 0 && (
      <TooltipTagsForStrategy
        title={
          <TagsBoxShowAll
            type="AccountAndProspect"
            currentSituationTags={
              strategy.tags?.map((tag) => ({
                externalPropertyId: tag.externalPropertyId,
                option: tag.value,
              })) ?? []
            }
            disableEdit={true}
            blockIsEditable={true}
            showRemovable={false}
          />
        }
        enterDelay={200}
        leaveDelay={200}
        PopperProps={{
          sx: {
            zIndex: '35002 !important',
          },
        }}
        placement="bottom-start"
      >
        <TagsTooltipForStrategyWrapper>
          {numerOfValuesSelected} {numerOfValuesSelected > 1 ? 'tags' : 'tag'}
        </TagsTooltipForStrategyWrapper>
      </TooltipTagsForStrategy>
    )
  );
};

export const TooltipTagsForStrategy = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip
      arrow={props.arrow ? props.arrow : false}
      {...props}
      classes={{ popper: className }}
    />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    position: 'relative',
    margin: '0px 16px 0px 0px',
    maxWidth: 400,
    width: 'fit-content',
    border: `1px solid ${colors.grey4}`,
    padding: 8,
    borderRadius: 16,
    WebkitBoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    MozBoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    OBoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    BoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    display: 'flex',
  },
}));

export default TagsTooltipForStrategy;
